
export default ({ selectType, idKey }) => {
  const INITIAL_STATE = {
    selectedCategory: null
  };

  return (state = INITIAL_STATE, action) => {
    switch(action.type) {
      case selectType:
        return {
          ...state,
          selectedCategory: action[idKey]
        };

      default:
        return state;
    }
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/categorySelectionMaker.js
 **/